import { render, staticRenderFns } from "./UserViewAddresses.vue?vue&type=template&id=26810708&"
import script from "./UserViewAddresses.vue?vue&type=script&lang=js&"
export * from "./UserViewAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports